/* eslint-disable */

/** unique or primary key constraints on table "argo.material_status" */
export enum ArgoMaterialStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  MaterialStatusPkey = 'material_status_pkey'
}

export enum ArgoMaterialStatusEnum {
  /** Material has been completed */
  Completed = 'completed',
  /** Material has had work performed */
  InProgress = 'in_progress',
  /** Material has been manually completed */
  ManuallyCompleted = 'manually_completed',
  /** Material has not been assigned a status */
  Pending = 'pending',
  /** Material has been quarantined */
  Quarantined = 'quarantined',
  /** Material has been scrapped */
  Scrapped = 'scrapped'
}

/** select columns of table "argo.material_status" */
export enum ArgoMaterialStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.material_status" */
export enum ArgoMaterialStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

